import React, { useEffect } from "react";
import { useDeclarationV2 } from "../DeclarationV2Context";
import PlanningMultiStep from "./PlanningMultiStep";
import PlanningSingleStep from "./PlanningSingleStep";

/** Étape 2 : calendrier à dates multiples (plusieurs cours) ou à date unique (un seul cours). */
const PlanningStep = () => {
    const { state, goTo } = useDeclarationV2();
    useEffect(() => {
        if (!state.student) goTo("student");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.student]);
    if (!state.student) return null;
    return state.courseType === "multiple" ? <PlanningMultiStep /> : <PlanningSingleStep />;
};

export default PlanningStep;
